export default "__VITE_ASSET__BjbO_Lnn__"